import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { QueryProvider } from '#/app/providers/query-provider'
import { router } from '#/app/router'
import { clearSession, refreshSession, restoreSession } from '#/modules/auth'
import { setSessionRefresher, setUnauthenticatedHandler } from '#/shared/api/http-client'
import '#/app/styles/index.css'
import '#/shared/config/i18n'

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element #root is missing from index.html')
}

// Wire the session into the http client before any request can fire. The
// client owns retrying a 401; it does not own where the refresh token lives, so
// the auth module hands it the two callbacks it needs.
setSessionRefresher(refreshSession)
setUnauthenticatedHandler(() => {
  clearSession()
  void router.navigate({ to: '/login' })
})

// Exchange the stored refresh token for an access token before the first
// render. Route guards read the session synchronously, so rendering earlier
// would bounce a signed-in operator to /login for one frame.
await restoreSession()

createRoot(rootElement).render(
  <StrictMode>
    <QueryProvider>
      <RouterProvider router={router} />
    </QueryProvider>
  </StrictMode>,
)
